
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-in-touch",
      function () {
        return require("private-next-pages/get-in-touch/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-in-touch"])
      });
    }
  